import Vue from './../_lib/vue/vue.min'
import VeeValidate from './../_lib/vue/vee-validate'
import vSelect from './../_lib/vue/vue-select'

// Validation customization
Vue.use(VeeValidate, {
    dictionary: {
        en: {
            custom: {
                email: {
                    required: 'Udfyld venligst din e-mail',
                    email: 'Udfyld venligst en gyldig e-mail'
                },
                fullname: {
                    required: 'Udfyld venligst dit fulde navn'
                },
                companyName: {
                    required: 'Udfyld venligst din virksomheds navn'
                },
                companyRegion: {
                    required: 'Vælg venligst en region'
                },
                tlf: {
                    required: 'Udfyld venligst dit telefonnummer'
                },
                gdprCheckbox: {
                    required: 'Acceptér venligst for at kunne fortsætte'
                }
            }
        }
    }
});

window.onload = function() {
    const leadTool = new Vue({
        el: '[data-lead-tool]',
        data() {
            return {
                step: 1,
                exportMarketSelectedItems: [],
                exportMarketSelectedGuids: []
            }
        },
        methods: {
            // Base
            prev() {
                window.scrollTo(0, 0);
                this.step--;
                window.scrollTo(0, 0);
            },
            next() {
                window.scrollTo(0, 0);
                this.step++;
                window.scrollTo(0, 0);
            },
            validateBeforeSubmit() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        document.getElementById('leadToolForm').submit();
                    }
                });
            },
            //Step 3
            primaryExportSector(event) {
                var radios = document.querySelectorAll("[name='primaryExportSector'][type='radio']"),
                    input = document.querySelector("[name='primaryExportSector'][type='text']"),
                    nextButton = document.querySelector('.primary-export-sector .next');

                // If there are input in textfield remove check on radios
                if (event.target.type === 'text') {
                    for (var i = 0, length = radios.length; i < length; i++) {
                        if (radios[i].checked && input.value !== '') {
                            radios[i].checked = false;
                        }
                    }
                }

                // If radio is checked remove text in textfield
                if (event.target.type === 'radio') {
                    input.value = '';
                }

                // If an input has value remove disable next step
                if (input.value !== '') {
                    nextButton.removeAttribute('disabled');
                }

                // If an input has value remove disable next step or set disable if all fields are empty 
                for (var i = 0, length = radios.length; i < length; i++) {
                    if (radios[i].checked) {
                        nextButton.removeAttribute('disabled');
                        break;
                    } else if (radios[i].checked === false && input.value === '') {
                        nextButton.setAttribute('disabled', 'disabled');
                    }
                }
            },
            //Step 4
            exportMarketOptionsSelected(event) {
                var select = document.querySelector('.export-market-select'),
                    undecidedRadio = document.querySelector('.export-market-undecided'),
                    guidsRadio = document.querySelector('.export-market-select-guids'),
                    nextButton = document.querySelector('.export-market-select-fieldset .next');

                // Disable at 3 selected markets
                if (event.length >= 3) {
                    select.classList.add('disabled');
                }
                // Remove disable if less that 3 selected markets
                if (event.length < 3) {
                    select.classList.remove('disabled');
                }
                // Check hidden radio if value
                if (event.length > 0) {
                    guidsRadio.checked = true;
                }

                // If both radio undecided is empty and guids is empty
                if (event.length === 0 && guidsRadio.checked === true && undecidedRadio.checked === false) {
                    guidsRadio.checked = false;

                    // Set disable if all fields empty
                    nextButton.setAttribute('disabled', 'disabled');
                }
                if (event.length !== 0 || undecidedRadio.checked) {

                    // Remove disable if a field has value
                    nextButton.removeAttribute('disabled');
                }
                // Uncheck undecided checkbox if an export market is selected
                if (event.length > 0 && undecidedRadio.checked) {
                    undecidedRadio.checked = false;
                }

                // Set value of select
                this.exportMarketSelectedGuids = [];
                var items = document.querySelector('.v-select').__vue__._data.mutableValue;
                for (var i = 0, length = items.length; i < length; i++) {
                    this.exportMarketSelectedGuids.push(items[i].value);
                }

            },
            exportMarketSelectClearDropdowns(event) {
                // Clear selected export markets when undecided is checked
                if (event.target.checked) {
                    document.querySelector('.v-select').__vue__._data.mutableValue = [];
                    this.exportMarketSelectedGuids = [];
                    
                }
            }
        },
        mounted() {
            if (document.getElementById("leadToolForm") && this.step < 7) {
                document.body.classList.add("lead-tool-page");
            }
        }
    });
};

Vue.component('v-select', vSelect);
